export default "__VITE_ASSET__17899475__"